import { CodeBook } from "@king-ict/eupisi-ui/models";

import { SchoolCandidate } from "./SchoolCandidate";

export interface UpdateSchoolCandidateInstitutionAssignment {
    institutionId?: CodeBook;
    schoolCandidateList: SchoolCandidate[];
}

export interface SaveSchoolCandidateInstitutionAssignment {
    institutionId?: number;
    schoolCandidateList: number[];
}

export interface UpdateSchoolCandidateInstitutionCountyAssignment {
    schoolCandidateId: number;
    institutionId?: number;
    uoguCountyId?: number;
    changeType: SchoolCandidateInstitutionChangeType;
}

export enum SchoolCandidateInstitutionChangeType
{
    Confirmation = 1,
    InstitutionChange = 2,
    CountyChange = 3,
}
